<template>
  <div class="agents-page">
    <div class="agents-container">
      <!-- 左侧：智能体案例 -->
      <div class="agents-sidebar">
        <h2 class="sidebar-title">智能体案例</h2>
        <div class="agents-list" v-loading="loading">
          <div
            v-for="item in agentItems"
            :key="item.id"
            class="agent-item"
            :class="{ active: selectedAgent?.id === item.id }"
            @click="selectAgent(item)"
          >
            <div class="agent-item-header">
              <div class="agent-title-row">
                <h3>{{ item.name }}</h3>
                <el-tag v-if="item.is_pinned" type="warning" size="small" effect="dark">置顶</el-tag>
              </div>
              <el-tag v-if="item.category" type="info" size="small">{{ item.category }}</el-tag>
            </div>
            <p v-if="item.description" class="agent-item-desc">{{ item.description }}</p>
          </div>
          <div v-if="agentItems.length === 0" class="empty-state">
            <el-empty description="暂无智能体" />
          </div>
        </div>
      </div>

      <!-- 右侧：智能体展示区 -->
      <div class="agents-content">
        <div v-if="selectedAgent" class="agent-display">
          <div class="agent-iframe-container">
            <iframe
              :src="selectedAgent.iframe_url"
              style="width: 100%; height: 100%;"
              frameborder="0"
              allow="microphone; camera; geolocation; payment; autoplay; encrypted-media"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation allow-downloads allow-presentation"
              referrerpolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
        <div v-else class="agent-placeholder">
          <el-empty description="请从左侧选择一个智能体" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'AgentsPage',
  data() {
    return {
      agentItems: [],
      selectedAgent: null,
      loading: false
    }
  },
  mounted() {
    this.loadAgents()
  },
  methods: {
    async loadAgents() {
      this.loading = true
      try {
        const response = await api.get('/agents/items/')
        if (Array.isArray(response.data)) {
          this.agentItems = response.data
        } else {
          this.agentItems = response.data.results || []
        }
        
        // 如果有智能体，默认选择第一个
        if (this.agentItems.length > 0 && !this.selectedAgent) {
          this.selectAgent(this.agentItems[0])
        }
      } catch (error) {
        console.error('加载智能体失败:', error)
        this.$message.error('加载智能体失败，请稍后重试')
        this.agentItems = []
      } finally {
        this.loading = false
      }
    },
    selectAgent(agent) {
      this.selectedAgent = agent
    }
  }
}
</script>

<style scoped>
.agents-page {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 20px;
}

.agents-container {
  display: flex;
  gap: 15px;
  height: calc(100vh - 200px);
  min-height: 600px;
}

.agents-sidebar {
  width: 280px;
  background: rgba(20, 20, 30, 0.8);
  border: 1px solid rgba(0, 150, 255, 0.2);
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
}

.sidebar-title {
  color: #e0e0e0;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 150, 255, 0.2);
}

.agents-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agent-item {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 150, 255, 0.1);
  border-radius: 6px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.agent-item:hover {
  border-color: rgba(0, 150, 255, 0.5);
  background: rgba(0, 150, 255, 0.1);
  transform: translateX(5px);
}

.agent-item.active {
  border-color: rgba(0, 150, 255, 0.8);
  background: rgba(0, 150, 255, 0.2);
}

.agent-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.agent-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.agent-item-header h3 {
  color: #e0e0e0;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  flex: 1;
}

.agent-item-desc {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.agents-content {
  flex: 1;
  min-width: 0;
  background: rgba(20, 20, 30, 0.8);
  border: 1px solid rgba(0, 150, 255, 0.2);
  border-radius: 8px;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.agent-display {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.agent-iframe-container {
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #fff;
  overflow: hidden;
}

.agent-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>

